module.exports = {
  available: false,
  customSplashBanner: "",
  customSplashBannerColor: "#dff902",
  slug: "cancun2021",
  name: "Cancun",
  year: "2021",
  region: "Mexico",
  country: "Mexico",
  location: "Cancun, Mexico",
  subscriptionFee: 80,
  taxesAndFees: 600,
  soldOut: false,
  useHawaiiPricing: false,
  useHawaiiPhoneGate: false,
  soldOutPercent: 0,
  soldOutPercentHawaii: 0,
  soldOutReferralTrip: "kauai2021",
  soldOutReferralText: "",
  banners: [""],
  thinBar1: "",
  thinBar2: "",
  saleEndsAt: "",
  onLocationPricingAvailable: true,
  onLocationPricingCutoff: "2020-09-28T06:00:00",
  onLocationMessage: "10 Spaces Remaining!",
  requireFirstNameForNewsletter: true,
  requireLastNameForNewsletter: true,
  requireFirstNameForNewsletterFooter: false,
  requireLastNameForNewsletterFooter: false,
  allowPayChangeDuringCheckout: true,
  dates: "May 9-15, 2021",
  timeZone: "EST",
  startTime: "8:00 PM (EST)",
  checkInDay: "Sunday",
  checkInDate: "May 9, 2021",
  checkInTime: "3:00 PM (EST)",
  arrivePriorTo: "5:30 PM (EST)",
  checkOutDay: "Saturday",
  checkOutDate: "May 15, 2021",
  checkOutTime: "12:00 PM (EST)",
  disableMonthlyPaymentOption: true,
  maxSubMonths: 9,
  useMaxSubMonthsCutoff: "09-28-2020",
  availabilityCutoff: "05-7-2020",
  departureAirport: "Cancun",
  departureAirCode: "CUN",
  venue: "The Ritz-Carlton, Cancun",
  venueSlug: "ritz-cancun",
  homeVideoId: 292085304,
  requestBrochureCategoryID: "3ca17a06e1",
  finalDetailsFormHash: "zbqshq518z0am8",
  finalDetailsFormEnabled: false,
  postponementFormHash: "",
  postponementFormEnabled: false,
  postponementFormExtHash: "",
  postponementFormExtEnabled: false,
  mainPageModal: {
    enabled: true,
    title: "Cancun 2021 Travelers",
    message:
      "Important Trip Update (1/29/21): An email update has been sent to your email address on file.",
    button: {
      text: "CANCUN 2021",
      path: "/cancun2021",
    },
  },
  tripPageModal: {
    enabled: true,
    dismissible: false,
    title: "LOVESONG | Cancun 2021 Travelers",
    messageAlignment: "left",
    message: `
      <p>Important Trip Update (1/29/21): An email update has been sent to your email address on file with the subject line LOVESONG | Cancun 2021 Important Traveler Update.</p>
      <p>If you do not see the email update in your inbox, please be sure to check your promotions tab in Gmail or spam folder as sometimes they do get caught in there.</p>
      <p>If you are still unable to locate the email, please contact us at customercare@everlastingtours.com to let us know and include the names that the reservation is under.      </p>
      <p>Blessings,<br />
        Everlasting Tours</p>
    `,
  },
  mapUrl:
    "https://www.google.com/maps?q=The+Ritz-Carlton,+Cancun&um=1&ie=UTF-8&sa=X&ved=0ahUKEwi2-OisuObaAhUK72MKHZOhDtAQ_AUICigB",
  perks: [
    "7 Days / 6 Nights The Ritz-Carlton, Cancun Accommodations",
    "Premium WiFi Access",
    "Complimentary Valet Parking",
    "Porterage Fees (Baggage Handling)",
    "Daily Housekeeping Gratuities",
    "Everlasting Tours OnLocation Staff",
    "Entertainment Wristbands ($500 value per person, included!)",
  ],
  subPerks: [
    "Speaking Sessions by Phenomenal Christian Speakers",
    "Performances by Chart Topping Christian Artists",
    "Morning Worship led by Musical Artists",
    "Meet & Greet Sessions with Speakers & Artists",
  ],
  lineup: [
  ],
  itinerary: [
    {
      name: "Sun",
      body:
        "\
        <p>\
          <strong>Day 1 | May 9</strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>\
            Resort Check-in & Love Song Registration\
          </strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Grand Opening with Troy Tyler<br />\
        Francesca Battistelli Performance</strong>\
        </p>",
    },
    {
      name: "Mon",
      body:
        "\
        <p>\
          <strong>Day 2 | May 10</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>\
            Worship with MercyMe & Devotion with Max Lucado<br />\
            Gary Thomas Sessions 1 & 2\
          </strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Optional Activity – Date Night in Paradise*</strong>\
        </p>",
    },
    {
      name: "Tue",
      body:
        "\
        <p>\
          <strong>Day 3 | May 11</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>\
            Worship with Mark Hall of Casting Crowns<br />\
            Gary Thomas Sessions 3<br />\
            Max Lucado Speaking Session\
          </strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>Optional Activity – Love Song Interactive*</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Free Time</strong>\
        </p>",
    },
    {
      name: "Wed",
      body:
        "\
        <p>\
          <strong>Day 4 | May 12</strong>\
        </p>\
        <p>\
          Morning & Afternoon:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>\
          Max Lucado Speaking Session<br />\
          Mark Hall of Casting Crowns Performance\
          </strong>\
        </p>",
    },
    {
      name: "Thu",
      body:
        "\
        <p>\
          <strong>Day 5 | May 13</strong>\
        </p>\
        <p>\
          Morning & Afternoon:<br />\
          <strong>\
            Optional Activity – Chichen Itza & Cenote Experience*\
          </strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Free Time</strong>\
        </p>",
    },
    {
      name: "Fri",
      body:
        "\
        <p>\
          <strong>Day 6 | May 14</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>Worship with Francesca Battistelli</strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>\
          Max Lucado Speaking Session<br />\
          MercyMe Performance</strong>\
        </p>",
    },
    {
      name: "Sat",
      body:
        "\
        <p>\
          <strong>Day 7 | May 15</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>Resort Checkout</strong>\
        </p>",
    },
  ],
  useCoupons: false,
  couponDisplay: 1,
  coupons: [],
  rooms: {
    "ocean-view": {
      key: "ocean-view",
      name: "Ocean View",
      kind: "room",
      trip: "cancun2021",
      upsell: "club-oceanview-king",
      prices: {
        default: 5998,
        onlocation: 4398,
      },
      extraNightPrices: {
        default: 450,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-ocean-view.jpg",
      header: "/images/rooms/cancun-ocean-view-header.jpg",
      description:
        "Spacious 435 sqft. guest room, Double/Double or one King (bedding type not guaranteed), balcony with beautiful ocean views, luxurious rain-shower and separate soaking tub, dual marble vanity, coffee maker, and more…",
    },
    oceanfront: {
      key: "oceanfront",
      name: "Ocean Front",
      kind: "room",
      trip: "cancun2021",
      upsell: "club-oceanview-king",
      prices: {
        default: 6198,
        onlocation: 4798,
      },
      extraNightPrices: {
        default: 500,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-oceanfront.jpg",
      header: "/images/rooms/cancun-oceanfront.jpg",
      description:
        "Spacious 435 sqft. guest room, Double/Double or one King (bedding type not guaranteed), balcony with panoramic oceanfront views, luxurious rain-shower and separate soaking tub, dual marble vanity, coffee maker, and more…",
    },
    
        "oceanfront-higherfloor": {
      key: "oceanfront-higherfloor",
      name: "Ocean Front - Higher Floor",
      kind: "room",
      trip: "cancun2021",
      upsell: "club-oceanview-king",
      prices: {
        default: 6198,
        onlocation: 4798,
      },
      extraNightPrices: {
        default: 500,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-oceanfront.jpg",
      header: "/images/rooms/cancun-oceanfront.jpg",
      description:
        "Spacious 435 sqft. guest room, Double/Double or one King (bedding type not guaranteed), balcony with panoramic oceanfront views, luxurious rain-shower and separate soaking tub, dual marble vanity, coffee maker, and more…",
    },
    
        standard: {
      key: "standard",
      name: "Standard",
      kind: "room",
      trip: "cancun2021",
      upsell: "ocean-view-king",
      prices: {
        default: 6398,
        onlocation: 4798,
      },
      extraNightPrices: {
        default: 500,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-ocean-view.jpg",
      header: "/images/rooms/cancun-standard-header.jpg",
      description:
        "[Limited View] Spacious 435 sqft. guest room, one King (bedding type guaranteed), luxurious rain-shower and separate soaking tub, dual marble vanity, coffee maker, and more…",
    },
    
    "standard-king": {
      key: "standard-king",
      name: "Standard - King Guaranteed",
      kind: "room",
      trip: "cancun2021",
      upsell: "ocean-view-king",
      prices: {
        default: 6398,
        onlocation: 4798,
      },
      extraNightPrices: {
        default: 500,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-ocean-view-king.jpg",
      header: "/images/rooms/cancun-standard-header.jpg",
      description:
        "[Limited View] Spacious 435 sqft. guest room, one King (bedding type guaranteed), luxurious rain-shower and separate soaking tub, dual marble vanity, coffee maker, and more…",
    },
    "ocean-view-king": {
      key: "ocean-view-king",
      name: "Ocean View - King Guaranteed",
      kind: "room",
      trip: "cancun2021",
      upsell: "oceanfront-suite",
      prices: {
        default: 6598,
        onlocation: 4998,
      },
      extraNightPrices: {
        default: 500,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-ocean-view-king.jpg",
      header: "/images/rooms/cancun-ocean-view-header.jpg",
      description:
        "Spacious 435 sqft. guest room, one King (bedding type guaranteed), balcony with beautiful ocean views, luxurious rain-shower and separate soaking tub, dual marble vanity, coffee maker, and more…",
    },
    
        "ocean-view-king-higherfloor": {
      key: "ocean-view-king-higherfloor",
      name: "Ocean View - King - Higher Floor",
      kind: "room",
      trip: "cancun2021",
      upsell: "oceanfront-suite",
      prices: {
        default: 6598,
        onlocation: 4998,
      },
      extraNightPrices: {
        default: 500,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-ocean-view-king.jpg",
      header: "/images/rooms/cancun-ocean-view-header.jpg",
      description:
        "Spacious 435 sqft. guest room, one King (bedding type guaranteed), balcony with beautiful ocean views, luxurious rain-shower and separate soaking tub, dual marble vanity, coffee maker, and more…",
    },
    
    
    "club-oceanview": {
      key: "club-oceanview",
      name: "Club Ocean View",
      kind: "room",
      trip: "cancun2021",
      upsell: "club-oceanview-king",
      prices: {
        default: 6798,
        onlocation: 4798,
      },
      extraNightPrices: {
        default: 600,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: true,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-ocean-view.jpg",
      header: "/images/rooms/cancun-ocean-view-header.jpg",
      description:
        "Club Access - Spacious 435 sqft. guest room, Double/Double or one King (bedding type not guaranteed), balcony with beautiful ocean views, luxurious rain-shower and separate soaking tub, dual marble vanity, coffee maker, and more…",
    },
    "oceanfront-king": {
      key: "oceanfront-king",
      name: "Ocean Front - King Guaranteed",
      kind: "room",
      trip: "cancun2021",
      upsell: "oceanfront-suite",
      prices: {
        default: 6798,
        onlocation: 5398,
      },
      extraNightPrices: {
        default: 550,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-oceanfront-king.jpg",
      header: "/images/rooms/cancun-oceanfront-king.jpg",
      description:
        "Spacious 435 sqft. guest room, one King (bedding guaranteed), balcony with panoramic oceanfront views, luxurious rain-shower and separate soaking tub, dual marble vanity, coffee maker, and more…",
    },
    "club-oceanview-king": {
      key: "club-oceanview-king",
      name: "Club Ocean View - King Guaranteed",
      kind: "room",
      trip: "cancun2021",
      upsell: "oceanfront-suite",
      prices: {
        default: 6998,
        onlocation: 5798,
      },
      extraNightPrices: {
        default: 650,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: true,
      note: "",
      image: "/images/rooms/cancun-ocean-view-king.jpg",
      header: "/images/rooms/cancun-ocean-view-header.jpg",
      description:
        "Club Access - Spacious 435 sqft. guest room, one King (bedding type guaranteed), balcony with beautiful ocean views, luxurious rain-shower and separate soaking tub, dual marble vanity, coffee maker, and more…",
    },
    "club-oceanfront": {
      key: "club-oceanfront",
      name: "Club Ocean Front",
      kind: "room",
      trip: "cancun2021",
      upsell: "oceanfront-suite",
      prices: {
        default: 7198,
        onlocation: 5198,
      },
      extraNightPrices: {
        default: 650,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-oceanfront.jpg",
      header: "/images/rooms/cancun-oceanfront.jpg",
      description:
        "Club Access - Spacious 435 sqft. guest room, Double/Double or one King (bedding type not guaranteed), balcony with panoramic oceanfront views, luxurious rain-shower and separate soaking tub, dual marble vanity, coffee maker, and more…",
    },
    "club-oceanfront-king": {
      key: "club-oceanfront-king",
      name: "Club Ocean Front - King Guaranteed",
      kind: "room",
      trip: "cancun2021",
      upsell: "oceanfront-suite",
      prices: {
        default: 7398,
        onlocation: 6398,
      },
      extraNightPrices: {
        default: 700,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-oceanfront-king.jpg",
      header: "/images/rooms/cancun-oceanfront-king.jpg",
      description:
        "Club Access - Spacious 435 sqft. guest room, one King (bedding guaranteed), balcony with panoramic oceanfront views, luxurious rain-shower and separate soaking tub, dual marble vanity, coffee maker, and more…",
    },
    "ocean-view-suite": {
      key: "ocean-view-suite",
      name: "Ocean View Suite",
      kind: "suite",
      trip: "cancun2021",
      upsell: "oceanfront-suite",
      prices: {
        default: 9198,
        onlocation: 7998,
      },
      extraNightPrices: {
        default: 750,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-suite.jpg",
      header: "/images/rooms/cancun-suite-header.jpg",
      description:
        "Elegant 876 sqft. suite, one King, furnished balcony with picturesque partial ocean views, lounging and sitting area with convenient powder room, luxurious walk-in rain-shower and separate soaking tub, dual marble vanity, walk-in closet, coffee maker, and more…",
    },
    "oceanfront-suite": {
      key: "oceanfront-suite",
      name: "Ocean Front Suite",
      kind: "suite",
      trip: "cancun2021",
      upsell: "club-ocean-view-suite",
      prices: {
        default: 9598,
        onlocation: 8598,
      },
      extraNightPrices: {
        default: 850,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: true,
      note: "",
      image: "/images/rooms/cancun-suite.jpg",
      header: "/images/rooms/cancun-suite-header.jpg",
      description:
        "Elegant 876 sqft. suite, one King, furnished balcony with breathtaking oceanfront views, lounging and sitting area with convenient powder room, luxurious walk-in rain-shower and separate soaking tub, dual marble vanity, walk-in closet, and more…",
    },
    "club-ocean-view-suite": {
      key: "club-ocean-view-suite",
      name: "Club Ocean View Suite",
      kind: "suite",
      trip: "cancun2021",
      upsell: false,
      prices: {
        default: 11398,
        onlocation: 10598,
      },
      extraNightPrices: {
        default: 1000,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-suite.jpg",
      header: "/images/rooms/cancun-suite-header.jpg",
      description:
        "Elegant 876 sqft. suite, one King, Club Level access, furnished balcony with picturesque partial ocean views, lounging and sitting area with convenient powder room, luxurious walk-in rain-shower and separate soaking tub, dual marble vanity, walk-in closet, and more…",
    },
    "club-oceanfront-suite": {
      key: "club-oceanfront-suite",
      name: "Club Ocean Front Suite",
      kind: "suite",
      trip: "cancun2021",
      upsell: false,
      prices: {
        default: 13398,
        onlocation: 11998,
      },
      extraNightPrices: {
        default: 1250,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-suite.jpg",
      header: "/images/rooms/cancun-suite-header.jpg",
      description:
        "Elegant 876 sqft. suite, one King, Club Level access, furnished balcony with breathtaking oceanfront views, lounging and sitting area with convenient powder room, luxurious walk-in rain-shower and separate soaking tub, dual marble vanity, walk-in closet, and more…",
    },
    "club-master-suite": {
      key: "club-master-suite",
      name: "Club Master Suite",
      kind: "suite",
      trip: "cancun2021",
      upsell: false,
      prices: {
        default: 14398,
        onlocation: 12598,
      },
      extraNightPrices: {
        default: 1500,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-suite.jpg",
      header: "/images/rooms/cancun-suite-header.jpg",
      description:
        "Elegant 876 sqft. suite, one King, located on Club Level with access, three balconies with sweeping ocean views, lounging and sitting area with convenient powder room, luxurious walk-in rain-shower and separate soaking tub, dual marble vanity, walk-in closet, and more…",
    },
    "ritz-carlton-suite": {
      key: "ritz-carlton-suite",
      name: "Ritz-Carlton Suite",
      kind: "suite",
      trip: "cancun2021",
      upsell: false,
      prices: {
        default: 15598,
        onlocation: 14998,
      },
      extraNightPrices: {
        default: 1750,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/cancun-ritz.jpg",
      header: "/images/rooms/cancun-ritz-header.jpg",
      description:
        "Extravagant 2460 sqft. suite, one King, Club Level access, located at highest level of resort, personal terrace with chaise lounges overlooking the ocean, oversized jacuzzi on terrace, luxurious walk-in rain-shower and separate soaking tub, dual marble vanity, walk-in closet, and more…",
    },
  },
};



// WEBPACK FOOTER //
// ./lib/trips/cancun2021.js